/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-filename-extension */
import React from "react";

import { Fade } from "react-awesome-reveal";

export default function AllTeam({ data }) {
  return (
    <section className="container mx-0 sm:mx-auto py-16">
      {/* About Us Section */}
      <div className="text-center mb-16">
        <h1 className="text-6xl text-theme-blue font-bold leading-tight mb-5 hover:text-indigo-700 transition-colors duration-300">
          About Us
        </h1>
        <p className="typewriter">
          We’re a tech-driven studio specializing in developing scalable
          solutions that elevate your brand and user experience.
          <br />
          By optimizing how you engage with your audience and enhancing the
          digital experiences you offer, we empower your website and digital
          platforms to provide exceptional value.
          <br />
          Our approach is rooted in strategic thinking, cutting-edge technology,
          and an unwavering commitment to results.
          <br />
          From building high-performance websites and mobile apps to
          streamlining processes through AI automation, we provide customized
          solutions that align with your business goals and drive tangible
          outcomes.
          <br />
          But we don't just create technology — we foster authentic connections.
          <br />
          Our goal is to create memorable digital experiences that help you
          build lasting relationships with your customers.
          <br />
          When you work with us, you're not just getting a service; you're
          gaining a partner in your journey to growth and success.
        </p>

        <div className="mt-8">
          <a
            href="https://www.ttptechllc.com/discuss-project"
            className="px-8 py-3 bg-theme-blue text-white text-xl font-semibold rounded-full shadow-lg transform hover:scale-105 transition-transform duration-300"
          >
            Let's Discuss Your Vision
          </a>
        </div>
      </div>

      {/* Team Cards Section */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-y-8 gap-x-32 sm:gap-14 lg:gap-10 mx-16 justify-items-center">
        {data.map((item, index) => (
          <Fade bottom delay={100 * index} key={index}>
            <a
              href={item.linkedinUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-col w-44 h-60 sm:w-56 sm:h-72 rounded-xl shadow-xl border border-light-theme-purple justify-center transform transition duration-500 hover:scale-105 hover:shadow-2xl hover:border-indigo-500 group"
            >
              <div className="flex justify-center mb-4">
                <img
                  src={item.imageUrl}
                  alt="Team Member"
                  className="w-32 h-32 rounded-full object-cover group-hover:scale-110 transition-transform duration-300"
                />
              </div>
              <h2 className="text-theme-blue text-center text-xl font-semibold transition-all duration-300 group-hover:text-indigo-600">
                {item.name}
              </h2>
              <p className="font-light text-gray-400 text-center mb-3 transition-opacity duration-500 opacity-80 group-hover:opacity-100">
                {item.position}
              </p>
            </a>
          </Fade>
        ))}
      </div>
    </section>
  );
}
